var map = {
	"./Approve Center.svg": 7571,
	"./Dashboard.svg": 66528,
	"./Exception Center.svg": 87889,
	"./Inbound.svg": 71526,
	"./Inventory Management.svg": 71730,
	"./Inventory Map.svg": 75614,
	"./Labor Management.svg": 34562,
	"./MT Inbound.svg": 94914,
	"./MT Outbound.svg": 15415,
	"./Query.svg": 20187,
	"./RTS Outbound.svg": 21118,
	"./Report Center.svg": 96441,
	"./Return Inbound.svg": 37362,
	"./Rule Center.svg": 60509,
	"./Sales Outbound.svg": 29589,
	"./System Config.svg": 32343,
	"./Transfer.svg": 28411,
	"./WH WCS.svg": 73685,
	"./WMS Basic.svg": 90762,
	"./Work Ticket Management.svg": 98055,
	"./back-arrow.svg": 27424,
	"./clock.svg": 87878,
	"./cycle-count-switcher.svg": 92802,
	"./del-btn.svg": 11814,
	"./edit.svg": 51620,
	"./email.svg": 43220,
	"./favourite.svg": 26951,
	"./google.svg": 30412,
	"./invisible.svg": 20189,
	"./left-arrow.svg": 51935,
	"./no-watch.svg": 32076,
	"./password.svg": 4729,
	"./right-arrow.svg": 1840,
	"./search-no-data.svg": 3054,
	"./shopee-mobile.svg": 87802,
	"./shopee-wms.svg": 24459,
	"./success.svg": 38507,
	"./system-out.svg": 7698,
	"./trash.svg": 14398,
	"./tv-icon.svg": 6230,
	"./user.svg": 76358,
	"./visible.svg": 78780,
	"./watch.svg": 77219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57678;